const alertsConfig = {
    topOffset: '140px',
    leftOffset: '300px',
    showDuration: 2500
};

export default alertsConfig;